import { ChangeEvent } from 'react';

import { ChevronDownIcon, Controller } from '@selina-finance/ui';

import SelectBox from '@Components/SelectBox/SelectBox';
import { getFormHelpers } from '@Shared/helpers/input';

export interface IMoveInControllerProps {
    index: number;
    notTouched: boolean;
    isPrimaryApplicant: boolean;
    addressItemName: string;
    formikProps: any;
    formItems: any;
}

export const MoveInController = ({
    index,
    notTouched,
    isPrimaryApplicant,
    addressItemName,
    formikProps,
    formItems,
}: IMoveInControllerProps) => {
    const { getError } = getFormHelpers(formItems, formikProps);

    return (
        <Controller
            label={`${
                isPrimaryApplicant
                    ? 'When did you move in?'
                    : 'When did they move in?'
            }`}
            className='mt-4'
        >
            <div className='grid grid-cols-1 gap-2 items-end grid-cols-2'>
                <SelectBox
                    items={formItems.month.items}
                    suffix={<ChevronDownIcon />}
                    label='Month'
                    labelSize='small'
                    placeholder='Month'
                    name='month'
                    validState={
                        !!formikProps.values.addresses[index].livedIn?.fromMonth
                    }
                    value={
                        formikProps.values.addresses[
                            index
                        ].livedIn?.fromMonth?.toString() || ''
                    }
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        formikProps.setTouched({
                            ...formikProps.touched,
                            [`${addressItemName}.livedIn.from`]: true,
                        });
                        formikProps.setFieldValue(
                            `${addressItemName}.livedIn.fromMonth`,
                            `${e.currentTarget.value}`,
                        );
                        formikProps.setFieldValue(
                            `${addressItemName}.livedIn.from`,
                            `${e.currentTarget.value}/${formikProps.values.addresses[index].livedIn?.fromYear}`,
                        );
                    }}
                    onBlur={() => {
                        return formikProps.setTouched({
                            ...formikProps.touched,
                            [`${addressItemName}.livedIn.from`]: true,
                        });
                    }}
                />

                <SelectBox
                    items={formItems.year.items}
                    suffix={<ChevronDownIcon />}
                    placeholder='Year'
                    label='Year'
                    labelSize='small'
                    name='year'
                    validState={
                        !!formikProps.values.addresses[index].livedIn?.fromYear
                    }
                    value={
                        formikProps.values.addresses[
                            index
                        ].livedIn?.fromYear?.toString() || ''
                    }
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        formikProps.setTouched({
                            ...formikProps.touched,
                            [`${addressItemName}.livedIn.from`]: true,
                        });
                        formikProps.setFieldValue(
                            `${addressItemName}.livedIn.fromYear`,
                            `${e.currentTarget.value}`,
                        );
                        formikProps.setFieldValue(
                            `${addressItemName}.livedIn.from`,
                            `${formikProps.values.addresses[index].livedIn?.fromMonth}/${e.currentTarget.value}`,
                        );
                    }}
                    onBlur={() => {
                        return formikProps.setTouched({
                            ...formikProps.touched,
                            [`${addressItemName}.livedIn.from`]: true,
                        });
                    }}
                />
            </div>
            <div className='mt-1.5 text-md text-red-500'>
                {getError(`${addressItemName}.livedIn.from`, notTouched)}
            </div>
        </Controller>
    );
};
